//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PLP from '@/scripts/libs/plp'

import RbCrosslinksRenderer from './rb-crosslinks-renderer.js'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
export default {
  name: 'RbCrosslinksWrapper',
  components: {
    RbCrosslinksRenderer,
  },
  data() {
    return {
      categoryNames: undefined,
      loading: true,
    }
  },
  computed: {
    children() {
      return this.$slots?.default?.filter((s) => s?.tag) || []
    },
    hasImage() {
      return this.children?.some((s) => {
        const keys = Object.keys(s?.componentOptions?.propsData)
        const rg = new RegExp(/image/g)
        return keys.find((k) => rg.test(k))
      })
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
  async created() {
    const slots = this.$slots.default || []
    const crosslinksWithShortcodes = slots.filter((slot) =>
      this.isShortcode(slot.componentOptions?.propsData?.label)
    )

    if (crosslinksWithShortcodes.length === 0) {
      this.categoryNames = []
    }

    const shortcodes = crosslinksWithShortcodes.map((slot) =>
      this.sanitizeShortcode(slot.componentOptions.propsData.label)
    )
    const categoryNames = await PLP.getCrosslinksFromCategoryNames({ categoryNames: shortcodes })
    this.categoryNames = categoryNames
    this.loading = false
  },
  methods: {
    isShortcode(label) {
      return label?.match(/\[\[.*\]\]/)
    },
    sanitizeShortcode(label) {
      return label?.replace('[[', '').replace(']]', '')
    },
  },
}
